import { Button, Row, Typography, useModal } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import GiftCardModal from "../GiftCardForm/GiftCardFormModal";
import ExportGiftCardsModal from "ui/giftcards/containers/ExportGiftCardsModal/ExportGiftCardsModal";
import LoadGiftCardsModal from "ui/giftcards/containers/LoadGiftCardsModal/LoadGiftCardsModal";
import useUserState from "ui/adapter/state/useUserState";
import { RoleType } from "common/models/role/Role";
import useSearchParam from "ui/common/hooks/useSearchParam";
import { LoadGiftCardStockModal } from "../LoadGiftCardStockModal/LoadGiftCardStockModal";
import { GiftCardStockStatus } from "common/models/api/models/GiftCardStock";
import { ExportGiftCardsStockModal } from "../ExportGiftCardsStockModal/ExportGiftCardsStockModalExportGiftCardsStockModal";

export default function GiftCardsRightToolbar() {
    const translate = useTranslate();
    const { showModal } = useModal();
    const { selectedRole } = useUserState();
    const isCustomerService = selectedRole?.roleType === RoleType.CUSTOMER_SERVICE;
    const [query] = useSearchParam("type");
    const giftCardType = query || GiftCardStockStatus.onDemand;

    return (
        <Row gap={10}>
            {!isCustomerService && giftCardType === GiftCardStockStatus.onDemand && (
                <Button variant="secondary" onClick={() => showModal(LoadGiftCardsModal)}>
                    <Typography variant="body2Strong">{translate("loadingVouchers")}</Typography>
                </Button>
            )}
            {!isCustomerService && giftCardType === GiftCardStockStatus.stock && (
                <Button variant="secondary" onClick={() => showModal(LoadGiftCardStockModal)}>
                    <Typography variant="body2Strong">{translate("loadingVouchersStock")}</Typography>
                </Button>
            )}
            {!isCustomerService && giftCardType === GiftCardStockStatus.onDemand && (
                <Button variant="secondary" onClick={() => showModal(ExportGiftCardsModal)}>
                    <Typography variant="body2Strong">{translate("export")}</Typography>
                </Button>
            )}
            {!isCustomerService && giftCardType === GiftCardStockStatus.stock && (
                <Button variant="secondary" onClick={() => showModal(ExportGiftCardsStockModal)}>
                    <Typography variant="body2Strong">{translate("exportGiftCardStock")}</Typography>
                </Button>
            )}
            {!isCustomerService && (
                <Button onClick={() => showModal(GiftCardModal)}>
                    <Typography variant="body2Strong">{translate("createGiftCard")}</Typography>
                </Button>
            )}
        </Row>
    );
}
